import { EventParams } from '../contracts';

export const getRedirectUrlWithStatus = (url: string, status: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}status=${status}`;
};

export const getRedirectUrlWithEventParams = (
  url: string,
  status: string,
  eventParams: Partial<EventParams> & { purchaseId?: string },
): string => {
  const urlObj = new URL(url);

  urlObj.searchParams.set('status', status);

  if (eventParams.date) urlObj.searchParams.set('date', eventParams.date);
  if (eventParams.sessionId) urlObj.searchParams.set('sessionId', eventParams.sessionId);
  if (eventParams.bundleName) urlObj.searchParams.set('bundleName', eventParams.bundleName);
  if (eventParams.bundleId) urlObj.searchParams.set('bundleId', eventParams.bundleId);
  if (eventParams.bundleSKU) urlObj.searchParams.set('bundleSKU', eventParams.bundleSKU);
  if (eventParams.totalSum !== undefined)
    urlObj.searchParams.set('totalSum', String(eventParams.totalSum));
  if (eventParams.totalSumCurrency)
    urlObj.searchParams.set('totalSumCurrency', eventParams.totalSumCurrency);
  if (eventParams.userId) urlObj.searchParams.set('userId', eventParams.userId);
  if (eventParams.userCountry) urlObj.searchParams.set('userCountry', eventParams.userCountry);
  if (eventParams.paymentMethodName)
    urlObj.searchParams.set('paymentMethodName', eventParams.paymentMethodName);
  if (eventParams.orderId) urlObj.searchParams.set('orderId', eventParams.orderId);
  if (eventParams.purchaseId) urlObj.searchParams.set('purchaseId', eventParams.purchaseId);
  if (eventParams.promoCode?.name) urlObj.searchParams.set('promoCode', eventParams.promoCode.name);
  if (eventParams.isSavedPaymentMethodUsed !== undefined) {
    urlObj.searchParams.set(
      'isSavedPaymentMethodUsed',
      String(eventParams.isSavedPaymentMethodUsed),
    );
  }
  if (eventParams.isNewPaymentMethodSaved !== undefined) {
    urlObj.searchParams.set('isNewPaymentMethodSaved', String(eventParams.isNewPaymentMethodSaved));
  }
  if (eventParams.products)
    urlObj.searchParams.set('products', JSON.stringify(eventParams.products));

  return urlObj.toString();
};
